import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpStoreView, HttpStoreViewOptions} from '../http/views.http'
import {View} from '../types'
import {QUERY_KEYS} from '@/queryClient'

export const useStoreView = (
    options?: Omit<UseMutationOptions<View, unknown, HttpStoreViewOptions['payload']>, 'mutationFn'>
) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: payload => httpStoreView({payload}),
        ...options,
        onSuccess: (data, variables, context) => {
            options?.onSuccess?.(data, variables, context)
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.VIEWS]})
        }
    })
}
